import type { ArcturianAvatarState, ArcturianOverlayIndicator } from '@/lib/voice-agent/ArcturianAvatarManifest'
import '@/arcturian-avatar.css'

interface ArcturianAvatarIndicatorProps {
  indicator: ArcturianOverlayIndicator
  state: ArcturianAvatarState
}

const LABELS: Record<Exclude<ArcturianOverlayIndicator, 'none'>, string> = {
  mic_level: 'Arcturian hört zu',
  activity_pulse: 'Arcturian denkt nach',
  error: 'Avatar nicht verfügbar',
}

/** Non-figurative state layer used when no dedicated motion clip exists. */
export function ArcturianAvatarIndicator({ indicator, state }: ArcturianAvatarIndicatorProps) {
  if (indicator === 'none') return null
  return (
    <div
      className={`arcturian-indicator arcturian-indicator--${indicator}`}
      data-avatar-state={state}
      role={indicator === 'error' ? 'status' : undefined}
      aria-label={LABELS[indicator]}
    >
      {indicator === 'mic_level' && (
        <span className="arcturian-indicator__meter" aria-hidden="true">
          <i /><i /><i /><i />
        </span>
      )}
      {indicator === 'activity_pulse' && <span className="arcturian-indicator__pulse" aria-hidden="true" />}
      {indicator === 'error' && <span className="arcturian-indicator__error" aria-hidden="true">!</span>}
    </div>
  )
}
